import { PERSONA_DERIVATION_CONTRACT } from '@backend-shared/voice/__fixtures__/audience-contract';

import type { OfficeType } from '@/hooks/use-org-profile';

export type Persona = 'political' | 'business' | 'legal' | 'nonprofit';

const PERSONAS = new Set<Persona>(['political', 'business', 'legal', 'nonprofit']);

export function isPersona(value: unknown): value is Persona {
  return typeof value === 'string' && PERSONAS.has(value as Persona);
}

/** Derive the audience persona, preferring an explicit organization override. */
export function personaForOrgType(
  organizationType?: string,
  override?: Persona,
  officeType?: OfficeType,
): Persona {
  if (override) {
    return override;
  }
  const text = (organizationType ?? '').toLowerCase();
  const tokens = new Set(text.split(/[^\da-z]+/).filter(Boolean));
  for (const { persona, keywords, phrases } of PERSONA_DERIVATION_CONTRACT) {
    if (
      keywords.some((keyword: string) => tokens.has(keyword)) ||
      phrases?.some((phrase) => text.includes(phrase))
    ) {
      return persona;
    }
  }
  return officeType === 'corporate' ? 'business' : 'political';
}
